//Views
PJQ.views.prequal.PrequalViewer = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Prequal-Form-Viewer'),
		subTemplates: {
			tab: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Prequal-Form-Viewer-Tab'),
			fieldCategory: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Prequal-Form-Field-Viewer-Category'),
			field: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Prequal-Form-Viewer-Field'),
			otherOffice: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Prequal-Form-Other-Office'),
			contact: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Prequal-Form-Contact'),
			projectReference: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Prequal-Form-Project-Reference')
		},
		tokens: {
			currentYear: PJQ.helpers.dateHelpers.getCurrentYear()
		},
		ignoreFieldTypes: [
			'groupselect',
			'regionselect',
			'download'
		]
	},
	events: {
		'click .prequal-export-pdf': 'exportPDF',
		'click .prequal-export-excel': 'exportExcel',
		'click .prequal-request-update': 'requestUpdate'
	},
	beforeFirstRender: function () {
		this.listenTo(this.model, "fetch", this.render);
	},
	beforeRender: function () {
		this.renderData = {
			model: this.model,
			renderTokens: _.bind(this.renderTokens, this)
		};
	},
	afterRender: function () {
		if (this.model.get('modifiedOn') != null) {
			this.renderForm();
		}
	},
	renderForm: function () {
		_.each(_.sortBy(_.filter(this.model.tabs, function (tab) {
			return _.size(tab.fields) > 0 && !tab.isHidden && _.find(tab.fields, function (field) {
				return this.options.ignoreFieldTypes.indexOf(field.fieldType.toLowerCase()) === -1
			}, this) != null
		}, this), function (tab) {
			return tab.sortOrder
		}), function (tab, index) {
			this.renderSubTemplate(true, this.options.subTemplates.tab, this.$('.prequal-tabs'), {
				index: index,
				tab: tab
			});
			let tabEl = this.getTabElement(tab.prequalTabId);

			//Render all of the fields for this tab
			_.each(_.sortBy(_.where(tab.fields, {isHidden: false}), function (field) {
				return field.sortOrder
			}), function (field) {
				let fieldDest = tabEl;
				if (field.category.length > 0) {
					let categoryId = this.model.categories.indexOf(field.category);
					if (categoryId < 0) {
						this.model.categories.push(field.category);
						categoryId = this.model.categories.indexOf(field.category);
					}
					if (this.getCategoryElement(tab.prequalTabId, categoryId).length === 0) {
						this.renderSubTemplate(true, this.options.subTemplates.fieldCategory, fieldDest, {
							category: this.renderTokens(field.category),
							categoryId: categoryId
						});
					}
					fieldDest = this.getCategoryElement(tab.prequalTabId, categoryId);
				}

				let self = this;
				this.renderSubTemplate(true, this.options.subTemplates.field, fieldDest, {
					field: field,
					renderTokens: _.bind(this.renderTokens, this),
					isEdit: true
				}, function ($input) {
					if (field.coreFieldName.toLowerCase() === 'otheroffices')
						self.renderOtherOffices(field);
					else if (field.coreFieldName.toLowerCase() === 'ownercontacts')
						self.renderOwnerContacts(field);
					else if (field.coreFieldName.toLowerCase() === 'operationscontacts')
						self.renderOperationsContacts(field);
					else if (field.coreFieldName.toLowerCase() === 'estimatingcontacts')
						self.renderEstimatingContacts(field);
					else if (field.coreFieldName.toLowerCase() === 'safetycontacts')
						self.renderSafetyContacts(field);
					else if (field.coreFieldName.toLowerCase() === 'projectreferences')
						self.renderProjectReferences(field);
					else if (field.fieldType.toLowerCase() === 'upload') {
						let fnInput = function (attachments) {
							new PJQ.views.files.FileUploaderGrid({
								el: $input.find('.file-uploader'),
								canUpload: false,
								canDelete: false,
								collection: attachments
							});
						};
						if (_.size(field.fieldValue) > 0) {
							new PJQ.ajax.Request({
								endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
									{
										endpoint: 'files'
									},
									{
										endpoint: 'details'
									}
								]),
								data: {
									guids: field.fieldValue.split('|')
								}
							}).post().done(function (result) {
								let attachments = new PJQ.collections.files.Files(result);
								fnInput(attachments);
							});
						}
						else {
							fnInput(new PJQ.collections.files.Files());
						}
					}
				});
			}, this);
		}, this);

		//remove the form-group class from the last item in each category
		//this just makes categories look better
		this.$('[data-field-category-id]').find('.prequal-field-container:last-child').find('.form-group').removeClass('form-group');

		_.each(this.model.fields, function (field) {
			this.renderFieldConstraints(field);
		}, this);

		//Loop through each tab and find non-hidden fields and add a background to the odd rows - ignoring fields in categories
		this.$('[data-tab-id]').each(function () {
			$(this).find('.prequal-field-container:not(.hidden):not(.prequal-constraint)').each(function (index) {
				if ($(this).closest('[data-field-category-id]').length === 0 && index % 2 > 0) {
					$(this).addClass('bg-muted');
				}
			});
		});

		//Loop through each category and find non-hidden fields and add a background to the odd rows
		this.$('[data-field-category-id]').each(function () {
			$(this).find('.prequal-field-container:not(.hidden)').each(function (index) {
				if (index % 2 > 0) {
					$(this).addClass('bg-muted');
				}
			});
		});

		//Update the prequal form percent complete on first load - we want to be sure this is up to date in the database as much as possible
		this.model.updateCompletion();

		this.renderCompletion();
	},
	getTabElement: function (tabId) {
		return this.$('[data-tab-id=' + tabId + ']');
	},
	getCategoryElement: function (tabId, categoryId) {
		return this.getTabElement(tabId).find('[data-field-category-id=' + categoryId + ']')
	},
	getFieldElement: function (fieldId) {
		return this.$('[data-field-id=' + fieldId + ']');
	},
	renderTokens: function (input) {
		return PJQ.templating.TemplateRenderer.parseMarkup(input, this.options.tokens);
	},
	renderFieldConstraints: function (field) {
		if (!field.constraints || field.constraints.length === 0)
			return;

		let controllerField = this.getFieldElement(field.prequalFieldId);
		//Loop through all of the fields which are controlled by this field
		_.each(_.where(field.constraints, {controlledByCustomFieldId: field.prequalFieldId}), _.bind(function (control) {
			//We cant loop through the constraints on the controller custom field because the custom field being controlled may have other constraints
			//So instead we check all of the fields which this constraint field relies on
			let controlField = this.model.fields[control.customFieldId],
				fieldContainer = this.getFieldElement(controlField.prequalFieldId).closest('.prequal-field-container');
			if (controllerField.hasClass('bg-muted'))
				fieldContainer.addClass('bg-muted');
			if (this.model.checkConstraintsMet(controlField)) {
				fieldContainer.removeClass('hidden');
			}
			else {
				fieldContainer.addClass('hidden');
			}
		}, this));
	},
	renderOtherOffices: function (field) {
		_.each(this.model.otherOffices.models, _.bind(function (office) {
			this.renderOtherOffice(field, office);
		}, this));
	},
	renderOtherOffice: function (field, office) {
		let fieldEl = this.getFieldElement(field.prequalFieldId);
		this.renderSubTemplate(true, this.options.subTemplates.otherOffice, fieldEl.find('.grid-items'), {
			field: field,
			item: office,
			isEdit: false,
			isViewer: true
		});
	},
	renderOwnerContacts: function (field) {
		this.renderContactsGrid(field, this.model.ownerContacts.models);
	},
	renderOperationsContacts: function (field) {
		this.renderContactsGrid(field, this.model.operationsContacts.models);
	},
	renderEstimatingContacts: function (field) {
		this.renderContactsGrid(field, this.model.estimatingContacts.models);
	},
	renderSafetyContacts: function (field) {
		this.renderContactsGrid(field, this.model.safetyContacts.models);
	},
	renderContactsGrid: function (field, models) {
		_.each(models, _.bind(function (model) {
			this.renderContactsGridItem(field, model);
		}, this));
	},
	renderContactsGridItem: function (field, contact) {
		let fieldEl = this.getFieldElement(field.prequalFieldId);
		this.renderSubTemplate(true, this.options.subTemplates.contact, fieldEl.find('.grid-items'), {
			field: field,
			item: contact,
			isEdit: false
		}, function (content) {
			PJQ.helpers.inputHelpers.inputMaskPhone(content.find('.input-phone'));
		});
	},
	renderProjectReferences: function (field) {
		_.each(this.model.projectReferences.models, _.bind(function (model) {
			this.renderProjectReference(field, model);
		}, this));
	},
	renderProjectReference: function (field, reference) {
		let fieldEl = this.getFieldElement(field.prequalFieldId);
		this.renderSubTemplate(true, this.options.subTemplates.projectReference, fieldEl.find('.grid-items'), {
			field: field,
			item: reference,
			isEdit: false,
			isViewer: true
		}, function (content) {
			new PJQ.inputs.Datepicker({
				el: content.find('.input-date'),
				datepickerOptions: {
					format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
					defaultDate: reference.get('dateCompleted')
				}
			});

			PJQ.helpers.inputHelpers.inputMaskCurrency(content.find('.input-dollars'));
			PJQ.helpers.inputHelpers.inputMaskPhone(content.find('.input-phone'));
		});
	},
	getCompletionColorClass: function (percent) {
		let textClass = 'danger';
		if (percent === 100)
			textClass = 'success';
		else if (percent > 60)
			textClass = 'warning';

		return textClass;
	},
	renderCompletion: function () {
		let progress = this.model.get('totalComplete'),
			colorClass = this.getCompletionColorClass(progress);
		if (this.totalProgressBar == null) {
			this.totalProgressBar = new PJQ.progress.ProgressBar(this.$('.prequal-progress'), {
				isShowPercentage: true,
				height: 40,
				colorClass: colorClass,
				progress: progress
			});
		}
		else {
			this.totalProgressBar.updateProgress(progress, colorClass);
		}
	},
	exportPDF: function () {
		this.export(false);
	},
	exportExcel: function () {
		this.export(true);
	},
	export: function (isExcel) {
		PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'contacts',
				value: this.model.contact.id
			},
			{
				endpoint: 'prequal'
			},
			{
				endpoint: 'export'
			}
		], [
			{
				parameter: 'masterUserId',
				value: this.model.get('masterUserId') > 0 ? this.model.get('masterUserId') : (PJQ.app.session.preferences.hasPref('portalOwner') ? PJQ.app.session.preferences.getPref('portalOwner') : PJQ.app.session.get('masterUserId'))
			},
			{
				parameter: 'isExcel',
				value: isExcel
			}
		]));
	},
	requestUpdate: function () {
		new PJQ.ajax.Request({
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'contacts',
					value: this.model.contact.id
				},
				{
					endpoint: 'prequal'
				},
				{
					endpoint: 'request'
				}
			])
		}).post().done(_.bind(function (data) {
			if (data) {
				PJQ.notifications.notify.successNotify({
					message: 'Qualification update sent'
				});
				this.$('.prequal-request-update').html('<i class="fal fa-check mr-1"></i>Update Sent').prop('disabled', true);
			}
			else {
				PJQ.notifications.notify.errorNotify({
					message: 'Qualification update failed, invalid email address on contact'
				});
			}
		}, this)).fail(function (xhr, err, result) {
			new PJQ.logging.Debug(PJQ.logging.LoggingActions.SEND_PREQUAL_UPDATE, {
				error: err,
				result: result
			});
		});
	}
});

PJQ.views.prequal.PrequalViewerModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Prequal-Viewer-Modal'),
		maxWidth: "1000px",
		width: "95%",
		masterUserId: null
	},
	beforeRender: function () {
		this.renderData = {
			model: this.model
		};
	},
	afterRender: function () {
		if (this.model != null) {
			this.model.fetch({
				success: _.bind(function () {
					let prequal = new PJQ.models.prequal.Prequal({
						contact: this.model,
						masterUserId: this.options.masterUserId
					});
					prequal.fetch({
						success: _.bind(function () {
							new PJQ.views.prequal.PrequalViewer({
								el: this.$('.prequal-container'),
								model: prequal
							});
						}, this)
					});
				}, this)
			});
		}
	}
});

PJQ.views.prequal.PrequalAuditLogModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'modal-prequal-auditlog'),
		minWidth: '1100',
		contactId: null
	},
	events: {},
	beforeModalCreated: function () {
		this.isFetched = false;

		this.data = new PJQ.collections.prequal.PrequalAuditLog(null, {
			contactId: this.options.contactId
		});
		this.data.fetch({
			success: _.bind(function(data) {
				this.isFetched = true;
				this.render();
			}, this)
		});
	},
	afterRender: function () {
		let loader = new PJQ.Loader(this.$('.auditlog-data'));
		if (!this.isFetched)
			return;
		else
			loader.remove();

		this.renderAuditLog()
	},
	renderAuditLog: function () {
		new PJQ.views.dataTables.DataTable({
			el: this.$('.auditlog-data'),
			pageLength: 25,
			isHideSearch: true,
			data: this.data.models,
			columns: [
				{
					"data": {
						"_": function (row) {
							return new Date(row.attributes.createdOn);
						},
						"filter": "attributes.createdOn",
						"display": function (row) {
							return PJQ.helpers.dateHelpers.getDateString(new Date(row.attributes.createdOn), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
						}
					},
					"title": "Date",
					"width": "80px",
					"orderable": false
				},
				{
					"data": {
						"_": function (row) {
							return row.attributes.createdBy.companyName + ' - ' + row.attributes.createdBy.contactName;
						},
						"display": function (row) {
							return '<span class="font-weight-light">'+row.attributes.createdBy.companyName + '</span>' + '<br />' + row.attributes.createdBy.contactName;
						}
					},
					"title": "Person",
					"width": "150px",
					"orderable": false
				},
				{
					"data": {
						"_": function (row) {
							return row.attributes.tabName + ' - ' + row.attributes.fieldName;
						},
						"display": function (row) {
							let html = '<span class="font-weight-light">'+row.attributes.tabName + '</span><br />';
							return  html + (row.attributes.category ? + row.attributes.category + '<br />' : '') + row.attributes.fieldName;
						}
					},
					"title": "Field",
					"width": "150px",
					"orderable": false
				},
				{
					"data": {
						"_": function (row) {
							return row.getValue(row.attributes.oldValue, row.attributes.fieldType);
						},
						"display": function (row) {
							return row.getValue(row.attributes.oldValue, row.attributes.fieldType);
						}
					},
					"title": "Original Value",
					"width": "30%",
					"orderable": false
				},
				{
					"data": {
						"_": function (row) {
							return row.getValue(row.attributes.newValue, row.attributes.fieldType);
						},
						"display": function (row) {
							return row.getValue(row.attributes.newValue, row.attributes.fieldType);
						}
					},
					"title": "New Value",
					"width": "30%",
					"orderable": false
				},

			]
		});
	}
});